var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInternalMaintenance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Toolbox",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.477,
    height: 17.29,
    viewBox: "0 0 22.477 17.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8019",
    "data-name": "Path 8019",
    d: "M189.019,111.426V119.6c0,.281-.03.471-.316.471H170.316c-.281,0-.316-.19-.316-.471v-8.174c0-.281.03-.432.316-.432h5.619a.484.484,0,0,1,.549.432v3.065a.389.389,0,0,0,.471.393h5.109a.389.389,0,0,0,.471-.393v-3.065a.484.484,0,0,1,.549-.432H188.7C188.989,110.994,189.019,111.145,189.019,111.426Zm-9.51,2.555a1.02,1.02,0,1,0-1.02-1.02A1.02,1.02,0,0,0,179.51,113.981Z",
    transform: "translate(-168.271 -102.781)",
    fill: "#37bdb0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8020",
    "data-name": "Path 8020",
    d: "M188.477,95.89H183.29V92H171.671a.052.052,0,0,0-.052.052V95.89H166v3.026h22.477Zm-16.426-3.458h10.806V95.89H172.052Z",
    transform: "translate(-166 -92)",
    fill: "#37bdb0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternalMaintenance);
export default __webpack_public_path__ + "static/media/Internal_Maintenance.f88e95e75a2432e3793a3f6a92d72129.svg";
export { ForwardRef as ReactComponent };